import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const BackButtonContainer = styled.div`
    display: flex;
    justify-content: end;
    margin-bottom: 20px;
`;

const Button = styled.button`
    background-color : #b72929;
    color : white;
    border: unset;
    height: 50px;
    width: 50px;
    font-size: 20px;
    cursor: pointer;
    transition: all ease 0.3s;
    box-shadow: 1px 1px 3px #4f4f4f;

    &:hover{
        transition: all ease 0.3s;
        box-shadow : inset 0px 0px 5px 10px #972121ff;
        box-shadow: 5px 5px 5px #4f4f4f;
        transform: translate(-5px, -5px);
    }

    @media (max-width: 768px) {
        height: 35px;
        width: 35px;
        font-size: 14px;

        &:hover{
            transition: all ease 0.3s;
            box-shadow: 3px 3px 3px #4f4f4f;
            transform: translate(-3px, -3px);
        }
    }
`;

function BackButton() {
    const navigate = useNavigate();

    return (
        <BackButtonContainer>
            <Button onClick={() => navigate(-1)}>
                ⬅
            </Button>
        </BackButtonContainer>
    );
}


export default BackButton;